<template>
    <numbering-check-settings
        model-name="saleinvoice"
        document-label="le fatture di vendita"
    />
</template>

<script>
import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

export default {
    name: 'saleinvoices-other',
    components: {
        NumberingCheckSettings
    }
}
</script>
